export const EL_CLASSNAME_NEXTAPP = "nextapp";

export const _experimental_isNextApp = "window" in global
  && document.documentElement.classList.contains(EL_CLASSNAME_NEXTAPP);

export const getEvnVariable = (key, envValue, defaultValue) => {
  let value = envValue;
  if (typeof window !== "undefined" && window.env && window.env[key]) {
    value = window.env[key];
  }
  return value ||  defaultValue;
};

export const getSentryDSN = () => getEvnVariable(
  "REACT_APP_SENTRY_DSN",
  process.env.REACT_APP_SENTRY_DSN,
  "https://afbc217bb2af4dfab407f6afe216e267@o4504169105850368.ingest.sentry.io/4504169109585920"
);

export const getEnvironment = () => getEvnVariable(
  "REACT_APP_ENVIRONMENT",
  process.env.REACT_APP_ENVIRONMENT,
  "development"
);

export const isStaging = () => getEnvironment() === "staging";
export const isProduction = () => getEnvironment() === "production";
export const isTest = () => getEnvironment() === "test";
export const isDevelopment = () =>  (
  process.env.NODE_ENV !== "production" && !isStaging() && !isProduction() && !isTest()
) || false;